import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { datetimeFormat } from '../../../utils';

const columns = [
	{ id: 'email', label: 'Email', minWidth: 150 },
	{
		id       : 'time',
		label    : 'Invited Date&Time',
		minWidth : 200,
		format   : (value) => (datetimeFormat(value))
	}
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`] : {
		backgroundColor : theme.palette.common.black,
		color           : theme.palette.common.white
	},
	[`&.${tableCellClasses.body}`] : {
		fontSize : 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)' : {
		backgroundColor : theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th' : {
		border : 0
	}
}));

const InvitesList = (props) =>
{
	const { open, handleClose, data } = props;

	return (
		<Dialog open={open}>
			<DialogTitle>Invited List</DialogTitle>
			<DialogContent>
				<Paper sx={{ width: '100%', overflow: 'hidden' }}>
					<TableContainer sx={{ maxHeight: 440 }}>
						<Table stickyHeader aria-label='sticky table'>
							<TableHead>
								<TableRow>
									{columns.map((column) => (
										<StyledTableCell
											key={column.id}
											align={column.align}
											style={{ minWidth: column.minWidth }}
										>
											{column.label}
										</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{data.map((row) =>
									(<StyledTableRow hover role='checkbox' tabIndex={-1} key={row._id}>
										{columns.map((column) =>
										{
											const value = row[column.id];

											return (
												<StyledTableCell key={column.id} align={column.align}>
													{column.format
														? column.format(value)
														: value}
												</StyledTableCell>
											);
										}
										)}
									</StyledTableRow>)
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</Paper>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

export default InvitesList;
